import { render, staticRenderFns } from "./ModalRuangan.vue?vue&type=template&id=948ccbfe&"
import script from "./ModalRuangan.vue?vue&type=script&lang=js&"
export * from "./ModalRuangan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports